import { render, staticRenderFns } from "./oilConfirm.vue?vue&type=template&id=acbf1356"
import script from "./oilConfirm.vue?vue&type=script&lang=js"
export * from "./oilConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports